<script>
import { mapActions } from "vuex";

export default {
  name: "FreeePartnerDialog",
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      page: 1,
      totalVisible: 7,
      partners: [],
      selectedItem: null,
      selectedRow: null,
      tableHeaders: [
        { text: '取引先コード', value: 'code' },
        { text: '名前', value: 'name' },
      ],
      searchForm: {
        keyword: null,
      },
    }
  },
  computed: {},
  watch: {
    enableDialog() {
      // 検索パネルを開いた状態にする.
      this.scrollToTop()
      this.partners = []
      this.page = 1
      Object.assign(this.$data.searchForm, this.$options.data().searchForm)
      if (this.selectedRow) {
        this.selectedRow.select(false)
      }
      this.selectedItem = null
    },

  },
  created() { },
  methods: {
    ...mapActions('DriverProviderFreeePartner', {
      fetchPartners: 'index',
    }),
    pageChangeEvent() {
      this.searchEmissions()
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent() {
      this.page = 1
      this.searchPartners()
    },
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent() {
      this.$emit('cancelCallback')
    },
    registerButtonClickEvent() {
      this.$emit("registerCallback", this.selectedItem)
    },
    prevPageButtonClickEvent () {
      this.page -= 1
      this.searchPartners()
    },
    nextPageButtonClickEvent () {
      this.page += 1
      this.searchPartners()
    },
    /**
     * 行選択イベント
     * @param item
     * @param row
     */
    rowClickEvent(item, row) {
      if (item.disabled) {
        if (this.selectedRow) {
          this.selectedRow.select(false)
          this.selectedRow = null
          this.selectedItem = null
        }
        return false
      }
      this.selectedItem = item
      this.selectedRow = row
      row.select(true)
    },
    /**
     * 行反映ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("registerCallback", row.item);
    },
    searchPartners() {
      this.fetchPartners({ page: this.page, condition: this.searchForm }).then((content) => {
        this.scrollToTop()
        this.partners = content.partners
      })
    },
    scrollToTop() {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName('card-layer')
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },
  }
}
</script>

<template>
  <v-dialog
    :value="enableDialog"
    persistent
    scrollable
    width="650"
    @keydown.esc="cancelButtonClickEvent"
    @close="cancelButtonClickEvent"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>freee取引先の検索</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text style="height: 56vh;max-height: 70vh;overflow-y: auto;">
        <!-- 検索ブロック -->
        <v-row class="mt-3" dense>
          <!-- 名称 -->
          <v-col cols="12">
            <v-text-field
              v-model="searchForm.keyword"
              dense
              hide-details="auto"
              label="名称"
              clearable
              outlined
              persistent-placeholder
              persistent-hint
              hint="取引先コード・取引先名のいずれかに対する部分一致。"
              rounded
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col class="text-right">
            <v-btn
              color="primary"
              @click="searchButtonClickEvent"
            >
              検索
            </v-btn>
          </v-col>
        </v-row>
        <!-- /検索ブロック -->
        <v-row dense>
          <v-col>
            <v-data-table
              :headers="tableHeaders"
              :items="partners"
              :items-per-page="-1"
              disable-sort
              fixed-header
              hide-default-footer
              single-select
              @click:row="rowClickEvent"
              @dblclick:row="rowDoubleClickEvent"
            >
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col class="text-right">
            <v-btn
              text
              :disabled="page === 1"
              @click="prevPageButtonClickEvent"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            &emsp;
            <v-btn
              icon
              :disabled="partners.length <= 0"
              @click="nextPageButtonClickEvent"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="cancelButtonClickEvent">
          閉じる
        </v-btn>
        <v-btn
          :disabled="!selectedItem"
          color="primary"
          @click="registerButtonClickEvent"
        >
          反映
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">

</style>
